import { createFileRoute } from '@tanstack/react-router'
import { PlanPage } from '../../../../features/commissions/plan-page'
import { planPageSearchSchema } from '../../../../features/commissions/search'

export const Route = createFileRoute('/_app/commissions/plans/$planId')({
  staticData: { crumb: 'commissionPlan' },
  validateSearch: planPageSearchSchema,
  component: PlanPage,
})
